import { NavLink, useLocation } from "react-router-dom";
import { User, Shield, Bell, Users } from "lucide-react";
import { useAPI } from "../Context/MyContext"; 

const ManageProfileSidebar = () => {
  const location = useLocation();
  const { getAllowedFeatures } = useAPI(); 

  return (
    <div className="w-72 bg-white border-r border-gray-200 min-h-screen relative">
      {/* Header */}
      <div className="p-6 border-b border-gray-200">
        <h2 className="text-2xl font-semibold text-gray-900">Account Settings</h2>
        <p className="text-sm text-gray-500 mt-1">Manage your account preferences</p>
      </div>

      {/* Navigation */}
      <nav className="p-4">
        <div className="space-y-1">
          <NavLink
            to="/manage-profile/profile"
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 ${isActive || location.pathname === "/manage-profile" // default active
                ? "bg-gradient-to-r from-green-50 to-emerald-50 text-green-600 shadow-sm border border-green-100"
                : "text-gray-700 hover:bg-gray-50 hover:text-gray-900"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <User
                  size={20}
                  className={isActive || location.pathname === "/manage-profile" ? "text-green-600" : "text-gray-400"}
                />
                <div className="flex-1">
                  <p className="font-medium text-sm">Your Profile</p>
                  <p className="text-xs text-gray-500">Personal information</p>
                </div>
              </>
            )}
          </NavLink>

          <NavLink
            to="/manage-profile/2fa"
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 ${isActive
                ? "bg-gradient-to-r from-green-50 to-emerald-50 text-green-600 shadow-sm border border-green-100"
                : "text-gray-700 hover:bg-gray-50 hover:text-gray-900"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Shield
                  size={20}
                  className={isActive ? "text-green-600" : "text-gray-400"}
                />
                <div className="flex-1">
                  <p className="font-medium text-sm">Two-Factor Auth</p>
                  <p className="text-xs text-gray-500">Extra security layer</p>
                </div>
              </>
            )}
          </NavLink>

          {getAllowedFeatures?.permissions?.allowAgentSettings && (
            <NavLink
              to="/manage-profile/agents"
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 ${isActive
                  ? "bg-gradient-to-r from-green-50 to-emerald-50 text-green-600 shadow-sm border border-green-100"
                  : "text-gray-700 hover:bg-gray-50 hover:text-gray-900"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <Users
                    size={20}
                    className={isActive ? "text-green-600" : "text-gray-400"}
                  />
                  <div className="flex-1">
                    <p className="font-medium text-sm">Agents</p>
                    <p className="text-xs text-gray-500">Manage agents</p>
                  </div>
                </>
              )}
            </NavLink>
          )}
        </div>
      </nav>

      {/* Footer */}
      <div className="absolute bottom-0 w-72 p-4 border-t border-gray-200 bg-gray-50">
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
          <div className="flex items-start gap-2">
            <Bell size={16} className="text-blue-600 mt-0.5" />
            <div>
              <p className="text-xs font-medium text-blue-900">Security Tip</p>
              <p className="text-xs text-blue-700 mt-1">
                Enable 2FA for better account security
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageProfileSidebar;
